import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import type { Insight } from "@/types/insight";
import { getInsightPath } from "@/utils/insightSlugs";

interface InsightCardHeaderProps {
  insight: Insight;
  language?: string;
}

const InsightCardHeader = ({ insight, language = 'EN' }: InsightCardHeaderProps) => {
  const displayTitle = language === 'KO' && insight.title_ko 
    ? insight.title_ko 
    : insight.title_en;

  const displayDescription = language === 'KO' && insight.description_ko
    ? insight.description_ko
    : insight.description_en;

  return (
    <div className="text-left">
      {insight.published_at && (
        <span className="mb-2 block text-[11px] font-medium uppercase tracking-wider text-gray-500">
          {format(new Date(insight.published_at), 'MMM d, yyyy')}
        </span>
      )}

      {insight.external_url ? (
        <a
          href={insight.external_url}
          target="_blank"
          rel="noopener noreferrer"
          className="group after:absolute after:inset-0 after:content-['']"
        >
          <h3 className="mb-2 text-[15px] font-semibold leading-snug tracking-[-0.01em] text-pretty [overflow-wrap:anywhere] text-gray-950">
            {displayTitle}
            <ExternalLink className="ml-1.5 inline-block h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
          </h3>
        </a>
      ) : (
        <Link to={getInsightPath(insight, language)} className="group after:absolute after:inset-0 after:content-['']">
          <h3 className="mb-2 text-[15px] font-semibold leading-snug tracking-[-0.01em] text-pretty [overflow-wrap:anywhere] text-gray-950">
            {displayTitle}
          </h3>
        </Link>
      )}

      <p className="mb-4 text-sm leading-6 text-gray-600 text-pretty">{displayDescription}</p>
    </div>
  );
};

export default InsightCardHeader;
